export enum WopiAccion {
  nuevo = "n",
  editar = "e",
  redactar = "r",
  responder = "re"
}
